import { useEffect, useState } from 'react';
import { SchedulerSidebarCrew } from './crew';
import { SchedulerSidebarChanges } from './changes';
import { SchedulerSidebarConfirmCrewAssignment } from './confirm/crewAssignment';
import { SchedulerSidebarConfirmCrewChanged } from './confirm/crewChanged';
import { useSchedulerSidebar } from '@contexts/scheduler/sidebar';
import { SchedulerSidebarContextData } from '@contexts/scheduler/sidebar/types';
import { cn } from '@utils/cn';
import { SchedulerSidebarEquipment } from './equipment';
import { SchedulerSidebarConfirmEquipmentAssignment } from './confirm/equipmentAssignment';
import { SchedulerSidebarConfirmEquipmentChanged } from './confirm/equipmentChanged';
import { useAccess } from '@hooks/access';

export const SchedulerSidebar = () => {
  const [crewExpanded, setCrewExpanded] = useState(true);
  const access = useAccess();
  const { confirm, disabled, equipmentMembers } =
    useSchedulerSidebar() as SchedulerSidebarContextData;
  const hasEquipment = equipmentMembers.length > 0;
  const [equipmentExpanded, setEquipmentExpanded] = useState(hasEquipment);

  useEffect(() => {
    if (hasEquipment) setEquipmentExpanded(true);
  }, [hasEquipment]);
  const confirmPopupsVisible =
    confirm?.crewAssignment.open ||
    confirm?.crewChanged.open ||
    confirm?.equipmentAssignment.open ||
    confirm?.equipmentChanged.open;

  return (
    <div className="flex h-full max-h-full min-h-0 w-full bg-white overflow-y-auto scrollbar-thin">
      <div className="flex h-full min-h-0 w-full flex-col">
        <div className={cn(confirmPopupsVisible ? 'shrink-0' : 'contents')}>
          <SchedulerSidebarConfirmCrewAssignment />
          <SchedulerSidebarConfirmCrewChanged />
          {!confirm?.crewAssignment.open && <SchedulerSidebarConfirmEquipmentAssignment />}
          {!confirm?.crewChanged.open && <SchedulerSidebarConfirmEquipmentChanged />}
        </div>
        <div className={cn('flex flex-col', disabled && 'bg-neutral-50')}>
          <SchedulerSidebarCrew expanded={crewExpanded} onExpandedChange={setCrewExpanded} />
          <SchedulerSidebarEquipment
            expanded={equipmentExpanded}
            onExpandedChange={setEquipmentExpanded}
          />
          {!access.readOnly && (
            <div>
              <SchedulerSidebarChanges />
            </div>
          )}
        </div>
      </div>
    </div>
  );
};
